import React, {useContext, useRef, useState} from "react";
import NIDGuide_image from "../../images/guide/NID_guide.png";
import Guid from "../Guid";
import Camera from "../Camera";
import Api from "../../tools/service";
import handleGenerateUuid from "../../tools/api/global/generateUuid";
import AuthenticationServiceContext from "../../tools/contexts/authenticatonService/AuthenticationServiceContext";
import {Reoverlay} from "reoverlay";
import ErrorModal from "../modals/ErrorModal";
import ProgressLoading from "../loading/ProgressLoading";
import REQUEST_URLS from "../../tools/defaults/requestUrl";
const NIDCardReader=()=>{
    const NidWebcam=useRef(null);
    const serviceContext=useContext(AuthenticationServiceContext)
    const [isLoading,setLoading]=useState(false)
    const NIDReaderGuidSlides=[
        {
            image:NIDGuide_image,
            title:"ونیفای",
            subTitle:"عکس کارت ملی (یا گواهینامه)",
            texts:`در شرایط نوری مناسب و از فاصله نزدیک از کارت ملی یا گواهینامه خود عکس بگیرید`
        }
    ];
    const onConfirm=(base64)=>{
        setLoading(true);
        handleGenerateUuid("NIDCardReader",serviceContext.token).then((uuid)=>{
            Api.post(REQUEST_URLS.AUTHENTICATION.NID_CARD_READER, {
                uuid: uuid,
                pid:serviceContext.pid,
                Image: base64 ? base64.replace('data:image/jpeg;base64,', '') : base64.replace('data:image/jpeg;base64,', ''),

            },{
                headers:{
                    "Authorization": `Bearer ${serviceContext.token}`
                },
            }).then((response) => {
                const {data, hasError,status, message} = response;
                if (!hasError) {
                    serviceContext.handleGetProcess(serviceContext.pid)
                } else {
                    serviceContext.handleError({
                        status:status,
                        message:message,
                        data:data,
                        hasError:hasError,
                        callback:()=>{
                            Reoverlay.showModal(ErrorModal,{
                                title:'خطا',
                                message:message||'خطای سرویس' ,
                                showConfirmButton:false,
                                showCancelButton:true,
                                cancelButtonText:'تلاش مجدد',
                                cancelButtonTheme:'red',

                                onCancel:()=>{
                                    Reoverlay.hideModal();

                                }
                            })
                        }
                    })
                    setLoading(false);
                }

            })
                .catch((error) => {
                    setLoading(true);
                }).finally(res => {

            });

        }).catch((error)=>{

        })
    }
    const [showGuide,setShowGuide]=useState(true);
    if(isLoading){
        return  <ProgressLoading showProgress={false} type="NIDCardReader" duration={30} text="در حال دریافت اطلاعات " theme="green"/>
    }
    return <div className="w-11/12 mt-5 md:w-5/12 mx-auto">
        {showGuide&&<Guid  imageClass={'w-8/12 md:w-8/12 lg:w-3/12 xl:w-2/12'} closeGuid={()=>setShowGuide(false)}  slides={NIDReaderGuidSlides}/> }
        {!showGuide&&<Camera webcamRef={NidWebcam} galleryEnable={false} handleShowGuid={()=>{setShowGuide(true)}} title={'عکس کارت ملی'} text={'در شرایط نوری مناسب از کارت ملی خود عکس بگیرید'}  faceMode="environment"  onCapture={onConfirm} isVideo={false} type="nid"/>}

    </div>
}
export default NIDCardReader;